import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import React from 'react';

const TableRU = () => {
  return (
    <Table
      style={{margin: '0 15px'}}
      dataSource={[
        { key: '1', permission: 'Создание условий доступа', admin: true, user: false },
        { key: '2',permission: 'Создание точки доступа',admin: true,user: false },
        { key: '3', permission: 'Редактирование настроек комнаты', admin: true, user: false },
        { key: '4',permission: 'Просмотр журнала действий',admin: true,user: false },
        { key: '5',permission: 'Удаление комнаты',admin: true,user: false },
        { key: '6',permission: 'Приглашение пользователей в комнату', admin: true,user: false },
        { key: '7',permission: 'Исключение пользователей из комнаты',admin: true,user: false },
        { key: '8', permission: 'Создание ролей', admin: true, user: false },
        { key: '9', permission: 'Изменение роли участника', admin: true, user: false },
        { key: '10', permission: 'Создание папок', admin: true, user: true },
        { key: '11', permission: 'Редактирование папок', admin: true, user: true },
        { key: '12', permission: 'Управление согласованием', admin: true, user: false },
        { key: '13', permission: 'Управление подписанием', admin: true, user: false },
        { key: '14', permission: 'Создание скриншота', admin: true, user: true },
      ]}
      columns={[
        {
          title: 'Права',
          dataIndex: 'permission',
          key: 'permission',
          width: '40%',
        },
        {
          title: 'Администратор',
          dataIndex: 'admin',
          key: 'admin',
          align: 'center',
          render: (hasPermission: boolean) =>
            hasPermission ? (
              <CheckOutlined style={{ color: 'green', fontSize: 20 }} />
            ) : (
              <CloseOutlined style={{ color: 'red', fontSize: 20  }} />
            ),
        },
        {
          title: 'Пользователь',
          dataIndex: 'user',
          key: 'user',
          align: 'center',
          render: (hasPermission: boolean) =>
            hasPermission ? (
              <CheckOutlined style={{ color: 'green', fontSize: 20  }} />
            ) : (
              <CloseOutlined style={{ color: 'red', fontSize: 20  }} />
            ),
        },
      ]}
      pagination={false}
      bordered
    />
  );
}

export default TableRU;
